import { Controller } from "@hotwired/stimulus"

// Auto-submits the input's owning form on change. Useful for file inputs
// (xlsx upload) and other "pick → submit immediately" UX.
//
// Usage on the input itself:
//   <input type="file" data-controller="auto-submit"
//          data-action="change->auto-submit#submit" form="fileForm" />
export default class extends Controller {
  submit(event) {
    const target = event.target
    const form = target.form || target.closest("form")
    if (form) form.submit()
  }
}
